exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".v-container[data-v-e804391e]{min-height:0}", "", {"version":3,"sources":["/Users/wvl/Workspaces/NowYu/nowyu-we/src/pages/Properties.vue"],"names":[],"mappings":"AACA,8BACI,YAAc,CACjB","file":"Properties.vue","sourcesContent":["\n.v-container[data-v-e804391e] {\n    min-height: 0;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e804391e","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/Properties.vue
// module id = 380
// module chunks = 0